import { onMounted, onUnmounted } from 'vue'

export function useContentProtection() {
  const preventDefault = (e: Event) => {
    e.preventDefault()
  }

  const preventShortcuts = (e: KeyboardEvent) => {
    // Prevent F12 (DevTools)
    if (e.key === 'F12') {
      e.preventDefault()
    }

    // Prevent Ctrl+Shift+I (DevTools)
    if (e.ctrlKey && e.shiftKey && e.key === 'I') {
      e.preventDefault()
    }

    // Prevent Ctrl+Shift+J (DevTools)
    if (e.ctrlKey && e.shiftKey && e.key === 'J') {
      e.preventDefault()
    }

    // Prevent Ctrl+Shift+C (Inspect Element)
    if (e.ctrlKey && e.shiftKey && e.key === 'C') {
      e.preventDefault()
    }

    // Prevent Ctrl+U (View Source)
    if (e.ctrlKey && e.key === 'u') {
      e.preventDefault()
    }

    // Prevent Ctrl+P (Print - leads to saving PDF)
    if (e.ctrlKey && e.key === 'p') {
      e.preventDefault()
    }

    // Prevent Ctrl+S (Save Page)
    if (e.ctrlKey && e.key === 's') {
      e.preventDefault()
    }
  }

  const handlePrintScreen = (e: KeyboardEvent) => {
    if (e.key === 'PrintScreen') {
      // Create a temporary overlay to block the screen content
      const overlay = document.createElement('div')
      overlay.style.position = 'fixed'
      overlay.style.top = '0'
      overlay.style.left = '0'
      overlay.style.width = '100vw'
      overlay.style.height = '100vh'
      overlay.style.backgroundColor = 'rgba(0,0,0,0.95)'
      overlay.style.zIndex = '99999'
      overlay.style.display = 'flex'
      overlay.style.alignItems = 'center'
      overlay.style.justifyContent = 'center'
      overlay.style.color = 'white'
      overlay.style.fontSize = '24px'
      overlay.style.fontWeight = 'bold'
      overlay.innerHTML = '<span>Screenshots are disabled on this application.</span>'

      document.body.appendChild(overlay)

      // Try to clear clipboard (only works in secure context and with permissions, but worth a try)
      if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText('').catch(() => {})
      }

      // Remove overlay after a short delay (enough to ruin the screenshot if OS takes it fast,
      // but usually OS takes it before we catch the event.
      // However, for some tools that delay or capture window, this might help.
      // More importantly, it signals the user.)
      setTimeout(() => {
        document.body.removeChild(overlay)
      }, 1000)
    }
  }

  onMounted(() => {
    // Disable Right Click
    document.addEventListener('contextmenu', preventDefault)

    // Disable Shortcuts
    document.addEventListener('keydown', preventShortcuts)

    // Detect PrintScreen
    document.addEventListener('keyup', handlePrintScreen)

    // Add User Select None class to body
    document.body.style.userSelect = 'none'
    document.body.style.webkitUserSelect = 'none' // Chrome/Safari
    ;(document.body.style as any).msUserSelect = 'none' // IE/Edge
    ;(document.body.style as any).mozUserSelect = 'none' // Firefox

    // Disable image dragging
    document.addEventListener('dragstart', preventDefault)

    // Anti-Snipping Tool (Hide content on blur)
    window.addEventListener('blur', hideContent)
    window.addEventListener('focus', showContent)
    document.addEventListener('visibilitychange', handleVisibilityChange)
  })

  const hideContent = () => {
    // Check if we already have an overlay
    if (document.getElementById('anti-screenshot-overlay')) return

    const overlay = document.createElement('div')
    overlay.id = 'anti-screenshot-overlay'
    overlay.style.position = 'fixed'
    overlay.style.top = '0'
    overlay.style.left = '0'
    overlay.style.width = '100vw'
    overlay.style.height = '100vh'
    overlay.style.backgroundColor = 'rgba(0,0,0,0.95)'
    overlay.style.zIndex = '999999'
    overlay.style.display = 'flex'
    overlay.style.alignItems = 'center'
    overlay.style.justifyContent = 'center'
    overlay.style.color = 'white'
    overlay.style.fontSize = '24px'
    overlay.style.fontWeight = 'bold'
    overlay.innerHTML = '<div style="text-align:center"><p>⚠️ Content Protected</p><p style="font-size:16px; font-weight:normal; margin-top:10px">Please return focus to this window to view content.</p></div>'

    document.body.appendChild(overlay)
    document.body.style.filter = 'blur(10px)'
  }

  const showContent = () => {
    const overlay = document.getElementById('anti-screenshot-overlay')
    if (overlay) {
      document.body.removeChild(overlay)
    }
    document.body.style.filter = 'none'
  }

  const handleVisibilityChange = () => {
    if (document.hidden) {
      hideContent()
    } else {
      showContent()
    }
  }

  onUnmounted(() => {
    document.removeEventListener('contextmenu', preventDefault)
    document.removeEventListener('keydown', preventShortcuts)
    document.removeEventListener('keyup', handlePrintScreen)
    document.removeEventListener('dragstart', preventDefault)

    window.removeEventListener('blur', hideContent)
    window.removeEventListener('focus', showContent)
    document.removeEventListener('visibilitychange', handleVisibilityChange)

    // Cleanup styles
    showContent()

    document.body.style.userSelect = ''
    document.body.style.webkitUserSelect = ''
    ;(document.body.style as any).msUserSelect = ''
    ;(document.body.style as any).mozUserSelect = ''
  })
}
